// extracted by mini-css-extract-plugin
module.exports = {"listItem":"RoommatesList_listItem__2a7Y_","deleteButton":"RoommatesList_deleteButton__13DTl"};